<template>
	<button
		v-if="!getProduct"
		class="product-add-to-cart button"
		type="button"
		aria-label="В корзину"
		@click="handleButtonClick"
	><span>В корзину</span>
		<i class="icon icon-cart"></i>
	</button>
	<CounterComponent
		v-else
		class="product-counter"
		:value="value"
		:max="max"
		@change="handleCounterChange"
	/>
</template>

<script setup lang="ts">
import CounterComponent from '@/shared/common/counter/counter-component.vue';
import { computed } from 'vue';

interface Props {
	id: string;
}

const props = defineProps<Props>();

const { store } = window.app;

const getProduct = computed(() => store.getProduct(props.id));
const value = computed(() => store.getQuantity(props.id));
const max = computed(() => store.getMaxOfProduct(props.id));

const handleButtonClick = (): void => {
	store.addToCart({ productId: props.id, quantity: 1 });
};

const handleCounterChange = (value: number): void => {
	if (value === 0) store.removeFromCart({ productId: props.id, quantity: 1 });
	else store.setProductQuantity({ productId: props.id, quantity: value });
};
</script>
